module.exports = __webpack_public_path__ + "static/media/td_analitica.fa910709.svg";